<template>
  <a @click.self="routeTo({ name: 'Product', params: { id: product.product_id }, query: { color_id: product.product_color_id}})"
     class="card" :class="{'grid-4': grid}">
    <div class="img_wrap_outer">
      <VueSlickCarousel
          :ref="'product_image_slider-'+product.product_color_id"
          v-bind="settings"
          class="img_wrap_inner"
          v-if="product.color_images && product.color_images.length > 1">
        <img
            @click.self="routeTo({ name: 'Product', params: { id: product.product_id }, query: { color_id: product.product_color_id}})"
            :src="image[280]" alt="product" class="active" v-for="(image, i) in product.color_images"
            :key="sliderKey+'-product-'+product.product_color_id+'-image-'+i">
        <template #customPaging="page" @click.stop>
          <div class="custom-dot">{{ page }}</div>
        </template>
      </VueSlickCarousel>
      <div class="img_wrap_inner" v-else-if="product.color_images && product.color_images.length">
        <img
            @click.self="routeTo({ name: 'Product', params: { id: product.product_id }, query: { color_id: product.product_color_id}})"
            :src="product.color_images[0][280]" alt="product" class="active">
      </div>
      <div class="img_wrap_inner" v-else>
        <img
            @click.self="routeTo({ name: 'Product', params: { id: product.product_id }, query: { color_id: product.product_color_id}})"
            src="/images/no-img.svg" alt="product" class="active">
      </div>
      <span class="discount" v-if="isAuth() && product.discount">-{{ product.discount.value }}{{
          product.discount.type
        }}</span>
      <span class="new_status" v-if="product.is_new">Новинка</span>
    </div>
    <div
        @click="routeTo({ name: 'Product', params: { id: product.product_id }, query: { color_id: product.product_color_id}})">
      <span class="code">{{ product.vendor_code }}</span>
      <span class="description">{{ product.name }} <span v-if="product.color_name">({{
          product.color_name
        }})</span></span>
      <div class="price_wrap" v-if="product.retail_price">
        <span class="old_price" v-if="product.discount_price">{{ product.retail_price }}</span>
        <span class="price" v-if="product.discount_price">{{ product.discount_price }} грн</span>
        <span class="price" v-else-if="product.retail_price">{{ product.retail_price }} грн</span>
      </div>
      <div class="size_wrapper" v-if="product.remains && product.remains.length > 0">
        <!--       XS, S, M, L, XL, XXL, XXXL-->
        <span :class="getColorRemainsForCard(size.remains)" v-for="(size, i) in product.remains"
              :key="sliderKey+'product-size-'+i+size.size">{{ size.size }}</span>
      </div>
    </div>
  </a>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import { colors } from '../../mixins/colors'
import router from '../../router'

export default {
  name: 'ProductCard',
  inject: ['isAuth'],
  props: {
    grid: Boolean,
    product: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: '',
          images: [],
          new_status: true,
          code: '',
          description: '',
          price: '',
          sizes: [],
          in_favourites: false
        }
      }
    },
    sliderKey: {
      type: String,
      default: 'p-slider'
    }
  },
  mixins: [
    colors
  ],
  components: {
    VueSlickCarousel
  },
  data () {
    return {
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        arrows: false,
        autoplaySpeed: 6000,
        variableWidth: false,
        dotsClass: 'product-item-dot'
      }
    }
  },
  methods: {
    routeTo (route) {
      router.push(route)
    }
  }
}
</script>

<style scoped>

</style>
